{
  "header": {
    "nameShowStaticText": true,
    "nameStaticText": "Used Model: OPC 40077",
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "56c952ec-3545-4490-bb02-8e95f8ac4a7a",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/IMM2MES/",
      "nodeId": "ns=1;i=6005",
      "displayName": "Model",
      "variablePath": "MachineInformation.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "pr_opc40077.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "a70e8910-8a43-4b79-94ab-2bdb8f78949c",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/IMM2MES/",
      "nodeId": "ns=1;i=6008",
      "displayName": "MachineMode",
      "variablePath": "MachineStatus.MachineMode",
      "dataType": "MachineModeEnumeration",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "colorValues": {
      "0": "#ffffff",
      "1": "#00ff00",
      "2": "#00ff00",
      "3": "#ffff00",
      "4": "#c8c8c8",
      "5": "#ff0000"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Machine Type",
              "showAsLink": false,
              "valueVariable": {
                "id": "d32433eb-9c09-4bba-9249-ae0bcdab02b1",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/IMM2MES/",
                "nodeId": "ns=1;i=6002",
                "displayName": "DeviceClass",
                "variablePath": "MachineInformation.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "bc8284f8-61b7-4b93-895a-82d974851861",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/IMM2MES/",
                "nodeId": "ns=1;i=6004",
                "displayName": "Manufacturer",
                "variablePath": "MachineInformation.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "56c952ec-3545-4490-bb02-8e95f8ac4a7a",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/IMM2MES/",
                "nodeId": "ns=1;i=6005",
                "displayName": "Model",
                "variablePath": "MachineInformation.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "0f1c6c2b-c3be-4785-983f-b39ed400f685",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/IMM2MES/",
                "nodeId": "ns=1;i=6017",
                "displayName": "SerialNumber",
                "variablePath": "MachineInformation.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Actual Temperature",
              "valueVariable": {
                "id": "82e20c04-1961-478a-af4c-c8dd6b684059",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/GeneralTypes/",
                "nodeId": "ns=1;i=6111",
                "displayName": "ActualTemperature",
                "variablePath": "ActualTemperature",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ],
          "placeholderObject": "InjectionUnits.InjectionUnit_<Nr>.[PLACEHOLDER].TemperatureZones.<TemperatureZone_Nr>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "50db3f6e-967e-42bc-b277-ca46b8f653fe",
            "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/GeneralTypes/",
            "nodeId": "ns=1;i=6116",
            "displayName": "Name",
            "variablePath": "Name",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Active Job",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Name",
              "showAsLink": false,
              "valueVariable": {
                "id": "28f18f2c-dc94-479e-8cc8-2cd6a63d4602",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/IMM2MES/",
                "nodeId": "ns=1;i=6088",
                "displayName": "ProductName",
                "variablePath": "Jobs.ActiveJob.ProductName",
                "dataType": "String",
                "valueRank": 1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#c8c8c8",
                  "textColor": "#000000",
                  "value": "0",
                  "label": "OTHER"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "1",
                  "label": "TRANSFERRED ASSIGNED"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "2",
                  "label": "SET_UP_ACTIVE"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "3",
                  "label": "SET_UP_INTERRUPTED"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "4",
                  "label": "SET_UP_FINISHED"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "5",
                  "label": "START_UP_ACTIVE"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "6",
                  "label": "JOB_IN_PRODUCTION"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "7",
                  "label": "JOB_INTERRUPTED"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "8",
                  "label": "JOB_FINISHED"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "9",
                  "label": "TEAR_DOWN_ACTIVE"
                },
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#ffffff",
                  "value": "10",
                  "label": "TEAR_DOWN_INTERRUPTED"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "11",
                  "label": "TEAR_DOWN_FINISHED"
                }
              ],
              "label": "Status",
              "valueVariable": {
                "id": "632aaa30-3e8a-4efc-89af-dfb1ef561fd8",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/IMM2MES/",
                "nodeId": "ns=1;i=6134",
                "displayName": "JobStatus",
                "variablePath": "Jobs.ActiveJobValues.JobStatus",
                "dataType": "JobStatusEnumeration",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    }
  ]
}
